export default "__VITE_ASSET__CHwNUDPk__"